import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnnouncementService } from '../services/announcement.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';

@Component({
  selector: 'app-announcement-list',
  templateUrl: './announcement-list.component.html',
  styleUrls: ['./announcement-list.component.css']
})
export class AnnouncementListComponent implements OnInit, OnDestroy {
  announcements = [];
  search;
  status = "active";
  user:any;
  driverList:any;
  preDriverList:any;
  constructor(
    private driverService : DriversService,
    private sharedDataService : SharedDataService,
    private announcementService : AnnouncementService
  ) { }

  ngOnInit() {
    this.getUser();
    this.getAnnouncementData();
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.getDriverList();
        }
      });
  }
  
  getAnnouncementData(){
    const queryParams = {
      status: this.status
    }
    this.announcementService.getAnnouncementList(queryParams).subscribe((data)=>{
      if(data){
        this.announcements = data;
      }
    })
  }

  onChangeStatus(evt) {
    this.getAnnouncementData();
  }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.driverList = data;
          this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      },
    );
  }

  ngOnDestroy() {
    
  }
}
